import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FormSearch } from 'app/models/dashboard/FormStatus';
import { BaseDashboard } from 'app/models/dashboard/BaseDashboard';
import { UtilityService } from 'app/services/utility.service';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root',
})
export class FundAdditionService {
	private readonly urlPath = `${environment.apiUrl}general-ledger/clients/`;

	constructor(private readonly httpClient: HttpClient, private readonly utilityService: UtilityService) {}

	createForm(clientId: string, request: any): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}${clientId}/forms/fund-addition`, request).pipe();
	}
	updateFundForm(clientId: string, request: any): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}${clientId}/forms/fund-addition/fund`, request).pipe();
	}

	updateForm(clientId: string, id: string, request: any): Observable<any> {
		return this.httpClient.put<any>(`${this.urlPath}${clientId}/forms/fund-addition/${id}`, request).pipe();
	}
	deleteDocument(clientId: string, formId: any, docId: any): Observable<any> {
		return this.httpClient.delete<any>(`${this.urlPath}${clientId}/forms/fund-addition/${formId}/docs/${docId}`);
	}
	getForm(clientId: string, id: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}${clientId}/forms/fund-addition/${id}`).pipe();
	}
	getFundForm(clientId: string, id: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}${clientId}/forms/fund-addition/${id}/fund`).pipe();
	}
	getAllFunds(clientId: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}${clientId}/forms/fund-addition/all`).pipe();
	}

	rejectForm(clientId: string, id: string, rejectionReason: { reason: string; workflowId: number }): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/forms/fund-addition/${id}/decline`, rejectionReason)
			.pipe();
	}

	approveForm(clientId: string, id: string, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/forms/fund-addition/${id}/approve`, {
				userId,
			})
			.pipe();
	}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		const url = `${
			this.urlPath
		}${clientId}/forms/fund-addition/users/${userId}?${this.utilityService.objectToQueryString(search)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	sendBack(clientId: string, id: string): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}${clientId}/forms/fund-addition/${id}/review`, {}).pipe();
	}

	uploadFile(clientId: string, id, file: File): Observable<HttpEvent<any>> {
		const formData: FormData = new FormData();
		formData.append('file', file);
		const req = new HttpRequest('POST', `${this.urlPath}${clientId}/forms/fund-addition/${id}/docs`, formData, {
			reportProgress: true,
			responseType: 'json',
		});
		return this.httpClient.request(req);
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/forms/fund-addition/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	getAccounts(clientId: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}${clientId}/forms/fund-addition/accounts`).pipe();
	}
}
